'use client'
import cn from 'classnames'
import Link from 'next/link'
import { FC, useMemo } from 'react'
import styles from './NavigationLink.module.scss'
import { usePathname } from 'next/navigation'
import { Icon, IconName } from '@/icons'

interface NavigationLinkProps {
  className?: string
  href: string
  title: string
  icon: IconName
}
export const NavigationLink: FC<NavigationLinkProps> = ({
  className,
  href,
  title,
  icon,
}) => {
  const pathname = usePathname()

  const isActive = useMemo(() => {
    return pathname === href
  }, [pathname, href])

  return (
    <Link
      href={href}
      className={cn(className, styles.container, {
        [styles.isActive]: isActive,
      })}
    >
      <Icon
        name={icon}
        className={cn(styles.icon, { [styles.isActive]: isActive })}
      />
      {title}
    </Link>
  )
}
